import React from "react";
import Morty from "../../image/Captura morty.png";
import nomiplanilla from "../../image/nomiplanillas.png";
import pokemones from "../../image/apiPokemones.png";
import marvel  from "../../image/apiMarvel.png";
import crud from "../../image/crudListaTareas.png";
import supermercado from "../../image/supermercado.png";
import simpson from "../../image/frasesSimpson.png";
import houseWinWin from "../../image/houseWinwin.png";
import youtube from "../../image/youtube.png";
import api from "../../image/apirest.png";

import "./ListCard.css";

const ListCard = () => {
  const [listProject, setListProject] = React.useState([

    {
      name: "Proyecto Supermercado",
      category:"Front: React, Redux, Javascript, Css, Html, Bootstrap",
      category2:"Back : Nodejs, Express, MongoDB",
      linkWeb: "",
      linkPhotoWeb: supermercado,
      comments: "Este  proyecto  se realizó con React, Redux, Javascript, Bootstrap , Express  y mongoDB como base de datos, en la cual se realiza un Crud de ventas de  productos. " ,
    },
    {
      name: "Pagina de Propiedades Raices HouseWinWin",
      category:"Front: Javascript, Css, Html",
      category2:"Back: json- Server ",
      linkWeb: "https://housewinwin.netlify.app/",
      linkPhotoWeb: houseWinWin,
      comments: "Esta es una pagina creada en  Javascript manila,  Css, html  y en el backend  se usa json- server  para realizar un crud al servidor.",
    },

    {
      name: "Proyecto de Nómina Javascript Manila",
      category:"Front: Javascript, Css, Html, Bootstrap",
      category2:" ",
      linkWeb: "https://nomiplanillas.netlify.app/",
      linkPhotoWeb: nomiplanilla,
      comments: "Esta es una pagina web creada en Html, Css , Bootstrap y Javascript  vanilla, la cúal presenta temas del área de nómina de Colombia, validador de retención en la fuente para empleados.",
        
    },
    {
      name: "Proyecto  Creador de Tareas ",
      category:"Front: React, Javascript, Css, Html",
      category2:" ",
      linkWeb: "https://creadortareas.netlify.app/",
      linkPhotoWeb: crud,
      comments: "Una app  creada en React, Css, NanoId,  con localStorage, la cual realiza el control de las tareas en un Crud.",
    },
    {
      name: "LLamado de Api de RicharMorty",
      category:"Front: React, Javascript, Html,Css",
      category2:" ",
      linkWeb: "https://richandmorty.netlify.app/",
      linkPhotoWeb: Morty,
      comments: "Esta es una Pagina creada en React  y Css  tipo onePage  en la cual se realiza el llamado de la api Richand Morty para ver sus personajes. ",
    },
  
    {
      name: "LLamado de Api Pokemones",
      category:"Front: React, Redux, Javascript, Css, Html, Bootstrap, React-Router-Dom",
      category2:" ",
      linkWeb: "https://apipokemones.netlify.app/",
      linkPhotoWeb: pokemones,
      comments: "Esta es una pagina creada en React, Redux, jsx, Css y Bootstrap la cual realiza el llamado de los personajes  de Pokemon con su foto.",
    },
    
    {
      name: "LLamado de Api Simsonp",
      category:"Front:  React, Javascript, Css, Html",
      category2:" ",
      linkWeb: "https://frases-simpson.netlify.app/",
      linkPhotoWeb: simpson,
      comments: "Esta es una pagina creada en React,  Css y Bootstrap, la cual realiza el llamado de los personajes  de los Simpson.",
    },

    {
      name: "Pagina de Youtube",
      category:"Front:  Javascript, Css, Html",
      category2:" ",
      linkWeb: "",
      linkPhotoWeb: youtube,
      comments: "Esta es una pagina creada en Html, Css y javascript la cual recrea el ambiente de Youtube  con la diferencia de poder ingresar, eliminar y actualizar videos.",
    }

   
    
  ]);


  const [listProjectBack, setlistProjectBack] = React.useState([
    {
      name: "Servicio de  Nómina Colombia",
      category:"Front: React, Redux, Javascript, Css, Html, Bootstrap, React-Router-Dom",
      category2:"Back: Java 17 spring boot   ",
      linkWeb: "",
      linkPhotoWeb: api,
      comments: "Actualmente en proceso : Servicio de nómina completo el cual realiza la creación de un empleado y los procesos de nómina, y cierre  de fin de mes (provisiones y seguridad social y informes terceros) en los cuales se puede cargar por archivo plano las novedades.",
    },


    {
      name: "Api Rest Microservicio de mensajeria   ",
      category:"Front: Swagger",
      category2:"Back: Java v 11  whit mysql",
      linkWeb: "https://github.com/Jaime-U-Lopez/MicroServicioMensajeriaFisica",
      linkPhotoWeb:api,
      comments: "Este microservicio esta pensado en solucionar los problemas creados en un proceso de mensajeria de paquetes fisicos.",
    },
   

    {
      name: "Api Rest Microservicio de Hoteleria ",
      category:"Front: Swagger",
      category2:"Back:  Java v 11  whit mysql ",
      linkWeb: "https://github.com/Jaime-U-Lopez/MicroHotel",
      linkPhotoWeb: api,
      comments: "Este microservicio esta pensado en solucionar los problemas creados en un proceso de hoteleria enfocado en el control de reservas.",
        
    },
    {
      name: "Api Rest Microservicio  de Cafeteria",
      category:"Front: Swagger , Thymeleaf",
      category2:"Back:  Java v 8  whit mysql ",
      linkWeb: "https://github.com/Jaime-U-Lopez/MicroServicioCafeteria",
      linkPhotoWeb: api,
      comments: "Este microservicio esta pensado en solucionar los problemas creados en un proceso de Cafeteria enfocado en el control de inventarios .",

    },
    {
      name: "Api Conexion entre Instacias o servidores (Procesamiento  de archivos de excel y csv)",
      category:"Front: ",
      category2:"Back: Java 11    ",
      linkWeb: "https://github.com/Jaime-U-Lopez/conexion_entre_microse_spring",
      linkPhotoWeb: api,
      comments: "Conexion entre microservicios para solicitud de respuestas y procesamientos logicos en diferentes instancias para la lectura y modificacion de archivos de excel y csv  .",
   
    }  
  
  ]);

  return (
    <div>

      <h1 className="TitleProject " >Project developer</h1>

      <h1 className="TitleProject " >Backend </h1>
   
      <p>Microservices made in Java with spring boot in which they were developed with good practices of clean code, respecting the solid principles
        and implementing design patterns like chain of responsibility, adapter, Factory. </p>


        <div className="container-characters container-fluid">
        {listProjectBack.map((item) => (
           
           <div className="character-container">
   
               <div className="card-body">
                 <h4 className="card-title">{item.name}</h4>
                 <h5 className="card-title">{item.category}</h5>
                 <h5 className="card-title">{item.category2}</h5>
                 <img src={item.linkPhotoWeb} alt="project" loazy="true" />
                 <div>
                   
                 <textarea readonly="readonly" rows="3" cols="26"className="card-text mt-2 mb-2">{item.comments}</textarea>
                 </div>
                 <a
                   href={item.linkWeb}
                   target="_blank"
                   className="btn btn-primary"
                 >
                   Go side web
                 </a>
               </div>
             </div>
    
         ))}


  
</div>

<h1 className="TitleProject " >Frontend </h1>
      <p>Applications and web pages created in React and Javascript manila. </p>

     
        <div className="container-characters container-fluid">
      {listProject.map((item) => (
           
        <div className="character-container">

            <div className="card-body">
              <h4 className="card-title">{item.name}</h4>
              <h5 className="card-title">{item.category}</h5>
              <h5 className="card-title">{item.category2}</h5>
              <img src={item.linkPhotoWeb} alt="project" loazy="true" />
              <div>
                
              <textarea readonly="readonly" rows="3" cols="26"className="card-text mt-2 mb-2">{item.comments}</textarea>
              </div>
              <a
                href={item.linkWeb}
                target="_blank"
                className="btn btn-primary"
              >
                Go side web
              </a>
            </div>
          </div>
 
      ))}

        
      </div>
    </div>
  );
};

export default ListCard;
